import { FadeUp, KineticText } from "@/components/KineticText";
import { ParallaxImage } from "@/components/ParallaxImage";
import { IMAGES, MANIFESTO } from "@/data/profile";

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="border-t hairline px-6 md:px-12 py-24 md:py-40">
    <div className="grid grid-cols-12 gap-6 md:gap-10">
      <div className="col-span-12 md:col-span-4">
        <div className="md:sticky md:top-32">
          <span className="eyebrow">Manifesto</span>
          <ParallaxImage
            src={IMAGES.portrait}
            alt="Michael J. Warden"
            className="aspect-[3/4] mt-8 border hairline"
            strength={8}
            shade={false}
            testId="portrait-image"
          />
          <p className="eyebrow mt-4">Fig. 01 — Michael J. Warden</p>
        </div>
      </div>

      <div className="col-span-12 md:col-span-7 md:col-start-6 space-y-24 md:space-y-40">
        {MANIFESTO.map((c, i) => (
          <article key={c.num} data-testid={`chapter-${c.num}`} className="border-t hairline pt-8">
            <div className="flex items-baseline gap-6 mb-8">
              <span className="eyebrow">[ {c.num} ]</span>
              <span className="eyebrow !text-[var(--accent)]">Chapter</span>
            </div>
            <KineticText
              as="h3"
              lines={[c.title]}
              className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9]"
            />
            <div className={`mt-10 grid grid-cols-12 gap-6 ${i % 2 === 1 ? "md:ml-24" : ""}`}>
              <FadeUp delay={0.15} className="col-span-12 md:col-span-6">
                <p className="text-base md:text-lg leading-relaxed text-muted">{c.body}</p>
              </FadeUp>
              <FadeUp delay={0.25} className="col-span-12 md:col-span-6">
                <ParallaxImage src={c.image} alt={c.caption} className="aspect-[4/5] border hairline" strength={10} shade={false} testId={`chapter-image-${c.num}`} />
                <p className="eyebrow mt-3 normal-case tracking-normal text-xs">{c.caption}</p>
              </FadeUp>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
